export default __webpack_public_path__ + "static/media/visor orange.4e867d36.png";